import { CollectionType } from '@enums/CollectionType';
import Collection, { QueryCollectionInfo } from '@models/Collection';
import ValidationError from '@models/ValidationError';

import { removeIdsFromSearchParams } from '../services/titles';
import { createAdminApi, getApiBaseUrl } from '../shared/utils';

type SaveCollectionRequest = Omit<
  Collection,
  'createdBy' | 'createdDateTime' | 'id' | 'updatedBy' | 'updatedDateTime'
> &
  // For existing collections
  Partial<Pick<Collection, 'id'>>;

export default SaveCollectionRequest;

const api = createAdminApi(`${getApiBaseUrl('layout')}/admin/collections`, {
  'x-api-version': '1.0',
});

export const createCollection = (data: SaveCollectionRequest) =>
  api.post<Collection | ValidationError>('', data);

export const saveCollection = (collectionObj: SaveCollectionRequest) =>
  api.put<Collection | ValidationError>(
    collectionObj!.id!,
    collectionObj.type === CollectionType.QUERY
      ? {
          ...collectionObj,
          data: removeIdsFromSearchParams(collectionObj.data as QueryCollectionInfo['data']),
        }
      : collectionObj
  );

export const fetchCollection = (id: string) => api.get<Collection>(id);

export const fetchAllCollections = () => api.get<Collection[]>('');

export const deleteCollection = (id: string) => api.delete(id);

export const fetchAllCollectionTags = () => api.get<string[]>('tags');
